import request from "../../../utils/request";

export const getUploadToken = (params) => {
  return request({
    method: "POST",
    path: "/tool-management/getUploadToken",
    params,
  });
};

// 列表
export const getActiveList = (params) => {
  return request({
    method: "GET",
    path: "/admin-management/getActiveList",
    params,
  });
};

// 创建活动
export const createActive = (params) => {
  return request({
    method: "POST",
    path: "/admin-management/createActive",
    params,
  });
};